// SPDX-FileCopyrightText: 2026 Igor Brkic <igor@hyperglitch.com>
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Browser entry point. Everything below this line runs client-side only; there
 * is no network access anywhere in the bundle (spec §2, §8).
 */

import { App } from './app.ts';

const root = document.getElementById('app');
if (root === null) {
  throw new Error('#app container missing from index.html');
}

try {
  new App(root);
} catch (err) {
  // Never show a raw stack trace in the UI (spec §7).
  root.replaceChildren();
  const box = document.createElement('div');
  box.className = 'banner bad';
  box.textContent = `The tool failed to start: ${(err as Error).message}`;
  root.append(box);
  throw err;
}
